<svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.8463 9.7297L15.3358 20.3043L25.0568 0.455778L9.8463 9.7297Z" fill="url(#paint0_linear_630_8580)"/>
<path d="M9.84707 9.72898L0.899873 7.61276L25.0575 0.455062L9.84707 9.72898Z" fill="url(#paint1_linear_630_8580)"/>
<defs>
<linearGradient id="paint0_linear_630_8580" x1="14.8661" y1="9.75923" x2="35.967" y2="5.15476" gradientUnits="userSpaceOnUse">
<stop stop-color="#4B59FF"/>
<stop offset="0.9992" stop-color="#B8BDFF"/>
</linearGradient>
<linearGradient id="paint1_linear_630_8580" x1="7.07571" y1="2.95202" x2="21.0947" y2="7.71256" gradientUnits="userSpaceOnUse">
<stop stop-color="#4B59FF"/>
<stop offset="0.9992" stop-color="#B8BDFF"/>
</linearGradient>
</defs>
</svg>
